import { WorkspaceStepValues } from "./tutorials.slice";

export const WorkspaceSteps = {
  [WorkspaceStepValues.workspaceTour]: [
    {
      target: ".demo_edit_access",
      content: "Add collaboraters to your workspace from here.",
      disableBeacon: true,
    },
    {
      target: ".demo_download_report",
      content: "Download the workspace as a report.",
      disableBeacon: true,
    },
    {
      target: ".demo_share_datapiece",
      content: "Share selected charts directly.",
      disableBeacon: true,
      // disableScrolling: true,
    },
    {
      target: ".demo_select_version",
      content: "Select versions for your workspace.",
      disableBeacon: true,
    },
    {
      target: ".demo_scroll_parent .demo_select_datapiece",
      content: "Select one or multiple charts from here for bulk action.",
      disableBeacon: true,
      // placement: "right",
      // disableScrolling: true,
    },
    {
      target: ".demo_download_selected_datapiece",
      content: "Download all selected charts.",
      disableBeacon: true,
      // disableScrolling: true,
    },
    {
      target: ".demo_pin_dashboard",
      content: "Pin selected charts to the Dashboard.",
      disableBeacon: true,
      // disableScrolling: true,
    },
    {
      target: ".demo_menu",
      content: "Right click on any chart for quick actions.",
      disableBeacon: true,
      // disableScrolling: true,
      placement: "right",
    },
  ],
  [WorkspaceStepValues.chatDatapiece]: [
    {
      target: ".demo_datapiece",
      content: "Hover over the data piece to see all the options.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_create_chat_icon",
      content: "Initiate a chat here",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_chat_input",
      content:
        "Type “@” followed by the name of the collaborators you want to add.",
      placement: "left",
      disableBeacon: true,
    },
    {
      target: ".demo_send_chat",
      content: "All done, start having data driven conversations!",
      placement: "left",
      disableBeacon: true,
    },
  ],
  [WorkspaceStepValues.trackingAnAction]: [
    {
      target: ".demo_datapiece",
      content: "Hover over the data piece to see all the options.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_chat_icon",
      content: "Click to expand chat.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_tracker_icon",
      content: "Click the icon to track this message.",
      placement: "left",
      disableBeacon: true,
    },
    {
      target: ".demo_tracker_date",
      content: "Set a date to track your action.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_tracker_recipients",
      content: "Select the recipients you want to collaborate with.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_tracker_done",
      content: "Click done to set your tracker in place.",
      placement: "right",
      disableBeacon: true,
    },
  ],
  [WorkspaceStepValues.settingAlert]: [
    {
      target: ".demo_datapiece",
      content: "Right-click on the data piece to see the options.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_data_alert_menu",
      content: "Select to create an alert.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_select_metrics",
      content: "Select the metrics you want to set alert on.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_alert_conditions",
      content: "Add one or multiple condition with the benchmark value.",
      placement: "left",
      disableBeacon: true,
    },
    {
      target: ".demo_alert_recipients",
      content: "Select the recipients you want to collaborate with.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_activate_alert",
      content: "Click create to activate the alert on your selected metrics.",
      placement: "top",
      disableBeacon: true,
    },
  ],
  [WorkspaceStepValues.addNewUser]: [
    {
      target: ".demo_add_user_tab",
      content: "Switch to user tab.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: ".demo_add_user_btn",
      content: "Click here to add user.",
      placement: "left",
      disableBeacon: true,
    },
    {
      target: ".demo_input_user_details",
      content: "Input user details",
      placement: "left",
      disableBeacon: true,
    },
    {
      target: ".demo_invite_user",
      content: "Send invite to the added user.",
      placement: "top",
      disableBeacon: true,
    },
  ],
  // [WorkspaceStepValues.addNewGroup]: [
  //   {
  //     target: ".demo_add_group_tab",
  //     content: "Switch to group tab.",
  //     placement: "right",
  //     disableBeacon: true,
  //   },
  //   {
  //     target: ".demo_add_group_btn",
  //     content: "Click to add a new group.",
  //     placement: "left",
  //     disableBeacon: true,
  //   },
  //   {
  //     target: ".demo_add_members_btn",
  //     content: "Click to add members to your group.",
  //     placement: "top",
  //     disableBeacon: true,
  //   },
  //   {
  //     target: ".demo_create_group",
  //     content: "Click create to add your group.",
  //     placement: "top",
  //     disableBeacon: true,
  //   },
  // ],
};
